<template>
    <div>
        <PageHeader :title="`${product} ${$t('pages.archive.title')}`"
                    class="intro-section"
                    :desc="$t('pages.archive.desc')">
            <span>
            {{$t('pages.archive.text')}}
         </span>
        </PageHeader>
        <PageFrameContainer>
            <div class="page-container">
                <div class="filters-panel">
                    <div class="filters-container">
                        <div v-for="p in platforms" v-bind:key="p">
                            <router-link
                                    v-if="platform !== p"
                                    class="filter-item"
                                    :to="{ name: 'archive', params: {product: product, platform: p, installerType: installerType,stable:stable } }">
                                {{platformTitleFilter(p)}}
                            </router-link>
                            <label
                                    v-else
                                    class="current-filter-item">
                                {{platformTitleFilter(p)}}
                            </label>
                        </div>
                        <div>
                            |
                        </div>
                        <div v-for="i in installerTypes" v-bind:key="i">
                            <router-link
                                    v-if="i !== installerType"
                                    class="filter-item"
                                    :to="{ name: 'archive', params: {product: product, platform: platform, installerType: i, stable:stable } }">
                                {{artefactTypeTitleFilter(i)}}
                            </router-link>
                            <label
                                    v-else
                                    class="current-filter-item">
                                {{artefactTypeTitleFilter(i)}}
                            </label>
                        </div>
                        <div>
                            |
                        </div>
                        <div v-for="s in stableArr" v-bind:key="s">
                            <router-link
                                    v-if="s !== stable"
                                    class="filter-item"
                                    :to="{ name: 'archive', params: {product: product, platform: platform, installerType: installerType, stable:s } }">
                                {{formatStableFilterTitle(s)}}
                            </router-link>
                            <label
                                    v-else
                                    class="current-filter-item">
                                {{formatStableFilterTitle(s)}}
                            </label>
                        </div>

                    </div>
                </div>
                <div class="versions-container">
                    <div class="versions-container-cells-header">
                    </div>
                    <label class="versions-container-cell-ver-header">{{$t('pages.archive.tableComponents.version')}}</label>
                    <label class="versions-container-cell-size-header">{{$t('pages.archive.tableComponents.size')}}</label>
                    <label class="versions-container-cell-date-header">{{$t('pages.archive.tableComponents.date')}}</label>
                    <label class="versions-container-cell-stable-header">{{$t('pages.archive.tableComponents.stable')}}</label>
                    <label class="versions-container-cell-download-header">{{$t('pages.archive.tableComponents.download')}}</label>

                    <template v-for="(item,index) in versions">
                        <label :key="'ver-'+item.ver" class="versions-container-cell-ver"
                               :style="{ gridRow:2+index}">{{item.ver}}</label>
                        <label :key="'size-'+item.ver" class="versions-container-cell-size"
                               :style="{ gridRow:2+index}">{{item.size | sizeMBFilter}}</label>
                        <label :key="'date-'+item.ver" class="versions-container-cell-date"
                               :style="{ gridRow:2+index}">{{item.date}}</label>
                        <div v-if="item.stable===true" :key="'stable-'+item.ver" class="versions-container-cell-stable"
                             :style="{ gridRow:2+index}">
                            <img src="./assets/icons/stable.svg" onerror="this.onerror=null"
                                 title="stable">
                        </div>
                        <div v-else :key="'stable-'+item.ver" class="versions-container-cell-stable"
                             :style="{ gridRow:2+index}">
                            <img src="./assets/icons/unstable.svg" onerror="this.onerror=null"
                                 title="unstable">
                        </div>
                        <router-link :key="'download-'+item.ver"
                                     :to="{ name: 'download', params: {product: product, version: item.ver, platform: platform, installerType: installerType } }"
                                     class="versions-container-cell-download" :style="{ gridRow:2+index}"
                                     title="download">
                            <img src="./assets/icons/download.svg" onerror="this.onerror=null" title="download">
                        </router-link>
                    </template>
                    <template v-for="(item,index) in versions">
                        <div :key="item.ver" class="versions-track"
                             :style="{ gridRow:2+index}"></div>
                    </template>
                </div>
            </div>
        </PageFrameContainer>
    </div>
</template>

<script>
    import PageFrameContainer from "./components/PageFrameContainer";
    import PageHeader from "./components/PageHeader";

    let artefactDb = require('./assets/data/db');
    export default {
        name: "ArchivePage",
        components: {PageHeader, PageFrameContainer},
        props: {
            product: String,
            installerType: String,
            platform: String,
            versions: Array,
            stable: Boolean
        },
        data: function () {
            return {
                installerTypes: [],
                products: [],
                platforms: [],
                stableArr: [],
                date: Date
            }
        },
        mounted: async function () {
            this.db = artefactDb;


            let inArray = function (_array, _comparer) {
                for (let i = 0; i < _array.length; i++) {
                    if (_comparer(_array[i])) return true;
                }
                return false;
            };

            let pushIfNotExist = function (_array, _element, _comparer) {
                if (!inArray(_array, _comparer)) {
                    _array.push(_element);
                }
            };
            let products = Object.keys(artefactDb);
            let platforms = [];
            let types = [];
            for (let product of products) {
                let productData = artefactDb[product];
                let platformsData = Object.keys(productData);
                for (let platform of platformsData) {
                    let productTypes = productData[platform];
                    pushIfNotExist(platforms, platform, function (e) {
                        return e.toLowerCase() === platform.toLowerCase();
                    });
                    let typesData = Object.keys(productTypes);
                    for (let type of typesData) {
                        pushIfNotExist(types, type, function (e) {
                            return e.toLowerCase() === type.toLowerCase();
                        });
                    }
                }
            }

            this.products = products;
            this.platforms = platforms;
            this.installerTypes = types;
            this.stableArr = [true, false];
            this.stable = this.$route.params['stable'].toString().toLowerCase() === 'true';
            await this.invalidate();
        },
        watch: {
            async installerType() {
                await this.invalidate();
            },
            async platform() {
                await this.invalidate();
            },
            async stable() {
                await this.invalidate();
            }
        },
        methods: {
            async invalidate() {
                let versions = [];
                for (let item of this.db[this.product][this.platform][this.installerType]) {
                    if (!this.stable || item["stable"] > 0)
                        versions.push({
                            ver: item["ver"],
                            size: item["size"],
                            link: item["link"],
                            stable: item["stable"] > 0,
                            date: item["date"]
                        });
                }

                this.versions = versions;

            },
            async stableCheckChanged() {
                await this.$router.push({
                    name: "archive",
                    params: {
                        product: this.product,
                        platform: this.platform,
                        installerType: this.installerType,
                        stable: this.stable
                    }
                });

            },
            async onClick() {
                await this.$router.push("/c/mapper/9.8.7");
            },
            async onClickSecret() {
                await this.$router.push({
                    name: "productInfo",
                    params: {product: "Studio", secret: "Some secret", version: "1.1.1.1"}
                });
            },
            formatStableFilterTitle(value) {
                switch (value) {
                    case true:
                        return this.$t('pages.archive.stable');
                    case false:
                        return this.$t('pages.archive.all');
                    default:
                        break;
                }
                return value;
            },
            artefactTypeTitleFilter(value) {
                switch (value.toLowerCase()) {
                    case "portablezip":
                        return this.$t('pages.archive.zip');
                    case "offlineinstaller":
                        return this.$t('pages.archive.installer');
                    default:
                        return value;
                }
            },
            platformTitleFilter(value) {
                switch (value.toLowerCase()) {
                    case "winx86":
                        return `32 ${this.$t('pages.archive.bit')}`;
                    case "winx64":
                        return `64 ${this.$t('pages.archive.bit')}`;
                    default:
                        return value;

                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "/theme/theme.scss";

    /*
    --------------------------------------------------------------------------------
    PAGE
    --------------------------------------------------------------------------------
    */
    .page-container {
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: auto 1em auto 1fr;
        width: 100%;
        height: 100%;
    }


    /*
    --------------------------------------------------------------------------------
    Title
    --------------------------------------------------------------------------------
    */
    .intro-section {
        span {
            color: $back20;
            font-size: 1rem;
            font-weight: 300;
        }
    }

    /*
    --------------------------------------------------------------------------------
    Filters
    --------------------------------------------------------------------------------
    */
    .filters-panel {
        grid-row: 1;
        display: grid;
        margin: auto;
    }

    .filters-container {
        grid-gap: 1em;
        display: grid;
        grid-auto-flow: column;
        font-size: 1.2em;
        border: $back20;

    }

    .filter-item {
        color: $text40;
        text-transform: uppercase;
        text-effect: none;
        text-decoration: none;

    }

    .filter-item .active {
        color: $primary40;
        text-transform: uppercase;
        text-effect: none;
        text-decoration: none;
    }

    .filter-item:hover {
        color: $accent60;
    }

    .current-filter-item {
        color: $text100;
        border-bottom: 0.1em solid $primary60;
        text-transform: uppercase;
    }

    .versions-container {
        grid-row: 3;
        display: grid;
        grid-template-columns: auto auto auto auto auto;
        grid-template-rows: auto;
        grid-column-gap: 1em;
        grid-row-gap: 0;
    }

    .versions-track {
        margin-bottom: 0;
        border-bottom: 0.1em solid $text20;
        z-index: -1;
        grid-column-start: 1;
        grid-column-end: 6;

        &:nth-child(even) {
            background: $back20;
        }

        &:nth-child(odd) {
            background: $back40;
        }
    }

    .versions-container label {
        font-size: 1.2em;
        padding: 0.3em;
        text-align: center;
    }

    .versions-container a {
        font-size: 1.2em;
        padding: 0.3em;
        text-align: center;
        text-decoration: none;
        border-bottom: 0;
        color: $primary40;
    }

    .versions-container a:hover {
        color: $primary60;
    }

    .versions-container a img {
        display: block;
        height: 1.2em;
        text-align: center;

    }

    .versions-container-cell-stable {
        grid-column: 1;
        text-align: center;
        align-self: center;
    }

    .versions-container-cell-date {
        grid-column: 2;
    }

    .versions-container-cell-ver {
        grid-column: 3;
    }

    .versions-container-cell-size {
        grid-column: 4;
    }


    .versions-container-cell-download {
        grid-column: 5;
        justify-self: center;
        cursor: pointer;
    }

    .versions-container-cell-download:hover {
        opacity: 0.5;
    }

    .versions-container-cells-header {
        grid-row: 1;
        grid-column-start: 1;
        grid-column-end: 6;
        background: $primary100;
        border-bottom: 0.1em solid $text60;
        z-index: -1;
    }

    .versions-container-cell-stable-header {
        grid-column: 1;
        grid-row: 1;
        color: $primaryText100;
    }

    .versions-container-cell-date-header {
        grid-column: 2;
        grid-row: 1;
        color: $primaryText100;
    }

    .versions-container-cell-ver-header {
        grid-column: 3;
        grid-row: 1;
        color: $primaryText100;
    }


    .versions-container-cell-size-header {
        grid-column: 4;
        grid-row: 1;
        color: $primaryText100;
    }


    .versions-container-cell-download-header {
        grid-column: 5;
        grid-row: 1;
        color: $primaryText100;
    }
</style>
